import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, map } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { UserService } from '@services/user.service';
import { InstanceService } from '@services/instance.service';

export const authMatchGuard: CanMatchFn = () => {
  return inject(AuthService).isAuthenticated();
};

export const loginRedirectGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (!auth.isAuthenticated()) {
    return inject(Router).createUrlTree(['/auth/login']);
  }
  return true;
};

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const userService = inject(UserService);
  const instanceService = inject(InstanceService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(
      ['/auth/login'],
      { queryParams: { returnUrl: state.url } }
    );
  }

  if (userService.me()) {
    return true;
  }

  return userService.getMe().pipe(
    switchMap(() => {
      const token = auth.getAccessToken();
      if (token.canSwitchInstances()) {
        return instanceService.getInstances();
      }
      return of(null);
    }),
    map(() => true)
  );
};
